import {
  ModalController
} from '@ionic/angular';
import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import {
  ClubTeeTimeSlots,
  DiscountPlayerClub,
  TeeTimeBooking,
  TeeTimeClubVoucher,
  TeeTimeClubVoucherSeries,
  TeeTimeDiscount
} from 'src/data/mygolf.data';
import * as moment from 'moment';
import {
  ClubFlightService
} from 'src/providers/club-flight-service/club-flight-service';
import {
  mygolfUtils
} from 'src/custom/mygolf2u-utils';
import {
  JsonService
} from 'src/json-util';

@Component({
  selector: 'app-deals',
  templateUrl: './deals.page.html',
  styleUrls: ['./deals.page.scss'],
})
export class DealsPage implements OnInit {
  @Input() prices: any;
  @Input() promoPrices: any;
  @Input() teeTimeSlotDisplay: any;
  @Input() bookingOptions: any;
  @Input() getAllowUpdatePostPayment: (type ? : string) => boolean;
  @Input() getClubPackages: (type?) => any;
  @Input() getSlotPrice: (param1, param2) => any;
  @Input() getPromoPlan: (param1, param2) => any;
  @Input() getNormalPlan: (param1, param2) => any;
  @Input() getJumboPlan: (param1, param2) => any;
  @Input() teeSlotNew: boolean;
  @Input() fromClub: boolean;
  @Input() clubs: ClubTeeTimeSlots;
  @Input() clubInfo: any;
  @Input() bookingSlot: TeeTimeBooking;
  @Input() currentPlayerId: number;
  @Input() playerVoucher: Array < TeeTimeClubVoucher > ;
  @Input() voucherSeries: Array < TeeTimeClubVoucherSeries > ;
  @Input() getEligibleDiscount: (param1, param2) => any;
  @Input() onEligibleClick: (type?) => any;
  showPackageDetails: boolean = false;

  @Input() currency: string = 'RM';
  @Input() dealsTitle: string = 'Packages Available';
  @Input() onlyDescription: boolean = false;


  constructor(
    private modalCtl: ModalController,
    private flightService: ClubFlightService,
    private mg2uUtil: mygolfUtils,
  ) {}

  ngOnInit() {}

  dismiss() {
    this.modalCtl.dismiss();
  }

  togglePackageDetails() {
    this.showPackageDetails = !this.showPackageDetails
  }

  numberWithCommas(x) {
    if (!x) return x;
    else return this.mg2uUtil.numberWithCommas(x);
  }

  togglePrices() {
    if (!this.teeSlotNew) {
      if (!this.fromClub) this.getCurrentPlayerVoucher();
      if (!this.fromClub) this.getPendingPlayerDiscountCard();
      this.getActiveClubDiscounts();
      this.getPlayerVoucherSeries();
    } else if (this.teeSlotNew) {
      if (!this.fromClub) this.getCurrentPlayerVoucher();
      if (!this.fromClub) this.getPendingPlayerDiscountCard();
      this.getActiveClubDiscounts();
      this.getPlayerVoucherSeries();
    }
  }

  getCurrentPlayerVoucher() {
    let _playerId;
    let _clubId;
    if (this.teeSlotNew) _clubId = this.clubs ? this.clubs.club.id : this.clubInfo.clubId
    else if (!this.teeSlotNew) _clubId = this.bookingSlot.clubData.id
    if (!this.fromClub) {
      _playerId = this.currentPlayerId;
    }
    this.flightService.getListPlayerVouchers(_playerId)
      .subscribe((playerVoucher: Array < TeeTimeClubVoucher > ) => {
        this.playerVoucher = playerVoucher.filter((pv) => {
          return pv.club.id === _clubId && !pv.redeemed;
        });
      });
  }

  playerDP;
  getPendingPlayerDiscountCard() {
    let _isEligible;
    let _pendingPDP = [];
    let _approvedPDP = [];
    let _pendingDiscountCards = [];
    let _playerId = this.currentPlayerId;
    let _clubId;
    if (!this.teeSlotNew) _clubId = this.bookingSlot.clubData.id;
    else if (this.teeSlotNew) _clubId = this.clubs ? this.clubs.club.id : this.clubInfo.clubId;
    this.flightService.getListAllPlayersCardDiscount(_clubId)
      .subscribe((data) => {
        let _pdp: Array < DiscountPlayerClub > ;
        if (data) _pdp = data.json();
        if (_pdp && _pdp.length > 0) {
          this.playerDP =
            _isEligible = _pdp.filter((p: DiscountPlayerClub) => {
              return p.club.id === _clubId && p.verified && p.playerDiscountProgram.player.id === _playerId
            })
        }
      }, (error) => {}, () => {})
  }
  playerActiveClubDiscount: Array < any > ;
  getActiveClubDiscounts() {
    this.playerActiveClubDiscount = [];
    if (!this.teeSlotNew) {
      if (!this.bookingSlot) return false;
      if (this.bookingSlot.slotAssigned && this.bookingSlot.slotAssigned.pricingPlanPromotional &&
        !this.bookingSlot.slotAssigned.pricingPlanPromotional.discountsApplicable) return false;
    } else {
      if (!this.teeTimeSlotDisplay) return false;
      if (this.teeTimeSlotDisplay && this.teeTimeSlotDisplay.slot &&
        this.teeTimeSlotDisplay.slot.pricingPlanPromotional &&
        !this.teeTimeSlotDisplay.slot.pricingPlanPromotional.discountsApplicable) return false;
    }
    let _clubId;
    if (!this.fromClub)
      if (this.teeSlotNew) _clubId = this.clubs && this.clubs.club ? this.clubs.club.id : this.clubInfo.clubId;
      else if (!this.teeSlotNew) _clubId = this.clubInfo ? this.clubInfo.clubId : this.bookingSlot.clubData.id
    else if (this.fromClub) _clubId = this.clubInfo && this.clubInfo.clubId ? this.clubInfo.clubId : this.bookingSlot.clubData.id;
    if (!_clubId) return false;
    let _playerId;
    if (!this.fromClub) _playerId = this.currentPlayerId;
    else if (this.fromClub && !this.teeSlotNew)
      _playerId = this.bookingSlot && this.bookingSlot.bookingPlayers.length > 0 ? this.bookingSlot.bookingPlayers[0].player.id : null;
    let _currentDate;
    if (!this.teeSlotNew)
      _currentDate = moment(this.bookingSlot.slotAssigned.teeOffDate).format("YYYY-MM-DD");
    else if (this.teeSlotNew)
      _currentDate = moment(this.teeTimeSlotDisplay.slot.teeOffDate).format("YYYY-MM-DD");
    if (!this.fromClub) {
      this.flightService.getApplicableDiscountsForPlayer(_clubId, _playerId, _currentDate)
        .subscribe((applicableDiscounts) => {
          if (applicableDiscounts) {
            let _appDiscounts = applicableDiscounts.filter((ad: TeeTimeDiscount) => {
              return !ad.availableForClubOnly
            })
            this.playerActiveClubDiscount.push(..._appDiscounts);
            this.playerActiveClubDiscount = this.playerActiveClubDiscount.filter((pcd) => {
              return pcd.active
            }).sort((a, b) => {
              if (a.discountProgram) {
                if (a.name < b.name) return -1
                else if (a.name > b.name) return 1
                else return -1
              } else if (b.discountProgram) {
                if (a.name < b.name) return -1
                else if (a.name > b.name) return 1
                else return -1
              } else return 0
            })
          }
        })
    }
    if (this.fromClub) {
      this.flightService.getActiveListClubDiscounts(_clubId, _currentDate)
        .subscribe((activeClubDiscounts: Array < TeeTimeDiscount > ) => {
          if (activeClubDiscounts) {

            this.playerActiveClubDiscount.push(...activeClubDiscounts);
            this.playerActiveClubDiscount = this.playerActiveClubDiscount.filter((pcd) => {
              return pcd.active
            }).sort((a, b) => {
              if (a.discountProgram) {
                if (a.name < b.name) return -1
                else if (a.name > b.name) return 1
                else return -1
              } else if (b.discountProgram) {
                if (a.name < b.name) return -1
                else if (a.name > b.name) return 1
                else return -1
              } else return 0
            })
          }
        })

    }
  }

  getPlayerVoucherSeries() {
    console.debug("get player voucher series - ", this.fromClub, this.clubInfo, this.clubs, this.teeTimeSlotDisplay)
    this.voucherSeries = [];

    if (!this.teeSlotNew) {
      if (!this.bookingSlot) return false;
      if (this.bookingSlot.slotAssigned && this.bookingSlot.slotAssigned.pricingPlanPromotional &&
        !this.bookingSlot.slotAssigned.pricingPlanPromotional.discountsApplicable) return false;
    } else {
      if (!this.teeTimeSlotDisplay) return false;
      if (this.teeTimeSlotDisplay && this.teeTimeSlotDisplay.slot &&
        this.teeTimeSlotDisplay.slot.pricingPlanPromotional &&
        !this.teeTimeSlotDisplay.slot.pricingPlanPromotional.discountsApplicable) return false;
    }
    let _clubId;
    if (!this.teeSlotNew) _clubId = this.bookingSlot && this.bookingSlot.clubData.id ? this.bookingSlot.clubData.id : this.clubs.club.id;
    else {
      if (this.fromClub) _clubId = this.clubInfo.clubId
      else if (!this.fromClub) {
        if (this.clubInfo) {
          if (this.clubInfo.id) _clubId = this.clubInfo.id;
          else if (this.clubInfo.clubId) _clubId = this.clubInfo.clubId;
          else _clubId = null
        } else if (this.clubs && this.clubs.club) {
          if (this.clubs.club.id) _clubId = this.clubs.club.id;
          else if (this.clubs.club.clubId) _clubId = this.clubs.club.clubId;
          else _clubId = null
        }
      }
    }
    let voucherSeries: Array < TeeTimeClubVoucherSeries > = [];
    this.flightService.getClubVoucherSeries(1, _clubId)
      .subscribe((data: any) => {
        if (data.totalInPage > 0 && data.items && data.items.length > 0) {
          voucherSeries = data.items;
          if (voucherSeries) {
            this.voucherSeries.push(...voucherSeries);
          }
        }
      });
  }


  getDealsAmount(
    amount: any,
    amountType: string,
    currency ? : any,
    item ? : any,
    type ? : string
  ) {
    if (!amount && type !== 'privilege') return '';
    let _currency;
    if (this.teeSlotNew) {
      _currency =
        this.teeTimeSlotDisplay.currency &&
        this.teeTimeSlotDisplay.currency.symbol ?
        this.teeTimeSlotDisplay.currency.symbol :
        this.teeTimeSlotDisplay.slot.currency.symbol;
    } else
      _currency = this.bookingSlot.clubData.address.countryData.currencySymbol;
    let _amount = amount;
    let _amountType = amountType;
    let _flightApply;
    let _bookingApply;
    let _amPMtype;

    if (type === 'privilege' && item.applicableRate) {
      if (this.teeSlotNew) {
        _amPMtype = moment(
          this.teeTimeSlotDisplay.slot.teeOffTime,
          'HH:mm:ss'
        ).format('a');
      } else if (!this.teeSlotNew) {
        _amPMtype = moment(
          this.bookingSlot.slotAssigned.teeOffTime,
          'HH:mm:ss'
        ).format('a');
      }
      if (_amPMtype === 'am') {
        _amount = item.applicableRate.amRate;
        _amountType = item.applicableRate.amRateType;
      } else if (_amPMtype === 'pm') {
        _amount = item.applicableRate.pmRate;
        _amountType = item.applicableRate.pmRateType;
      }
    }
    if (type === 'privilege') {
      _bookingApply = item.appliesToBooking;
    } else {
      _flightApply = item.appliesToFlight;
      _bookingApply = item.appliesToBookingAmount;
    }
    let _amountText;
    let _flightTxt;
    let _maxFlightSize = item && item.maxFlightSize ? item.maxFlightSize : 4;
    if (type === 'voucher') {
      if (_flightApply) _flightTxt = 'for flight of ' + _maxFlightSize;
      else _flightTxt = 'for 1 person';
    } else if (type === 'privilege') {
      if (_bookingApply) _flightTxt = 'for booking amount';
      else _flightTxt = 'for covered items';
    }
    if (_amountType === 'Absolute') {
      _amountText = 'Save ' + _currency + '&nbsp;' + _amount;
    } else if (_amountType === 'Fixed' || _amountType === 'Package') {
      _amountText = 'Pay up to ' + _currency + '&nbsp;' + _amount;
    } else if (_amountType === 'Percentage') {
      _amountText = _amount + '% off';
    }
    if (type === 'voucher') return _amountText + ' ' + _flightTxt;
    else if (type === 'privilege') return _amountText + ' ' + _flightTxt;
    else return _amountText;
  }

  getDateText(date: string) {
    if (date.length === 0) return false;
    let _date = date;
    return moment(_date, 'YYYY-MM-DD').format("DD MMM 'YY");
  }

  getDiscountText(discount: TeeTimeDiscount, type ? : string) {



    if (!discount) return false;
    let _currency;
    let _discountDetails = discount; //this.getDiscountDetails(discount);
    if (!_discountDetails) return false;
    _currency = discount.club.address.countryData.currencySymbol;
    switch (type) {
      case 'amount':
        if (discount.amountType.toLowerCase() === 'percentage')
          return discount.discount + '% off';
        else if (discount.amountType.toLowerCase() === 'absolute')
          return 'Less ' + _currency + ' ' + discount.discount
        else if (discount.amountType.toLowerCase() === 'fixed')
          return _currency + ' ' + discount.discount
      case 'appliesFor':
        // HBUGGYFEE
        // HCADDYFEE
        // BUGGYFEE
        // CADDYFEE
        let _appliesFor = 'Covers ';
        let _priceComponents;



        if (_discountDetails && _discountDetails.priceComponents.length === 0) return;
        let _buggyFee = _discountDetails.priceComponents.filter((price) => {
          if (price.priceComponent.id.toLowerCase() === 'buggyfee')
            return true
          if (price.priceComponent.id.toLowerCase() === 'hbuggyfee')
            return true
          else return false
        });

        let _caddyFee = _discountDetails.priceComponents.filter((price) => {
          if (price.priceComponent.id.toLowerCase() === 'caddyfee')
            return true;
          if (price.priceComponent.id.toLowerCase() === 'hcaddyfee')
            return true;
          else return false;
        });



        _priceComponents = _discountDetails.priceComponents.filter((price) => {
          if (_buggyFee.length === 2) return price.priceComponent.id.toLowerCase() !== 'hbuggyfee'
          else return true
        }).filter((price) => {

          if (_caddyFee.length === 2) return price.priceComponent.id.toLowerCase() !== 'hcaddyfee'
          else return true
        });


        // if(price.priceComponent.id.toLowerCase() === 'hbuggyfee' && price.priceComponent.id.toLowerCase() === 'buggyfee')
        //     return price.priceComponent.id.toLowerCase() === 'buggyfee' && price.priceComponent.id.toLowerCase() !== 'hbuggyfee'
        // else if(price.priceComponent.id.toLowerCase() === 'HCADDYFEE' && price.priceComponent.id.toLowerCase() === 'caddyfee')
        //     return price.priceComponent.id.toLowerCase() !== 'caddyfee' && price.priceComponent.id.toLowerCase() !== 'hcaddyfee'
        // else return true

        if (_priceComponents && _priceComponents.length > 0) {
          if (!_discountDetails.priceComponents || _discountDetails.priceComponents.length === 0) return '';
          // setTimeout(()=>{
          _appliesFor += _priceComponents
            .sort((a, b) => {
              if (a.priceComponent.name < b.priceComponent.name) return -1
              else if (a.priceComponent.name < b.priceComponent.name) return 1
              else return 0
            })
            .map((a) => {
              return a.priceComponent.name
            }).reduce((a, b) => {
              return a + ', ' + b;
            })

          // },500)
        }
        return _appliesFor;

      case 'appliesTo':
        let _appliesTo = 'Applies to ';
        if (!_discountDetails.playerTypes || _discountDetails.playerTypes.length === 0) return '';
        _appliesTo += _discountDetails.playerTypes
          .map((a) => {
            return a.bookingPlayerType.name
          }).reduce((a, b) => {
            return a + ', ' + b;
          })

        return _appliesTo;
    }
  }

  escapeCRLF(value) {
    return JsonService.escapeCRLF(value);
  }
  
  getVoucherApplicableText(voucher: TeeTimeClubVoucherSeries, type: string) {
    // TeeTimeClubVoucher
    if (!voucher) return false;
    let _allowText;
    let _applicableStart = 'Applicable on';
    let _allowWeekdays;
    let _allowWeekends;
    let _allowHolidays;
    let _applicableEnd = '';
    let _voucherDetails = voucher;
    if (type === 'allowDays') {
        _allowWeekdays = (voucher && voucher.allowOnWeekdays && (voucher.allowOnWeekends && voucher.allowOnPublicHolidays) ? 'Weekdays' + ', ' : voucher && voucher.allowOnWeekdays ? 'Weekdays' : '');
        _allowWeekends = (voucher && voucher.allowOnWeekends && (voucher.allowOnWeekdays) && voucher.allowOnPublicHolidays) ? 'Weekends' : (voucher && voucher.allowOnWeekdays && voucher.allowOnWeekends && !voucher.allowOnPublicHolidays) ? ' and ' + 'Weekends' : (voucher && !voucher.allowOnWeekdays && voucher.allowOnWeekends) ? 'Weekends' : '';
        _allowHolidays = (voucher && ((voucher.allowOnWeekdays || voucher.allowOnWeekends) && voucher.allowOnPublicHolidays) ? ' and ' + 'Public Holidays' : voucher && voucher.allowOnPublicHolidays ? 'Public Holidays' : '');

        // _allowWeekdays = (voucher && (voucher.allowOnWeekends || voucher.allowOnPublicHolidays) ? 'Weekdays' + ', ' : voucher && voucher.allowOnWeekdays ? 'Weekdays' : '');
        // _allowWeekends = (voucher && voucher.allowOnPublicHolidays ? 'Weekends' + ', ' : voucher && voucher.allowOnWeekends ? 'Weekends' : '');
        // _allowHolidays = (voucher && (voucher.allowOnWeekdays || voucher.allowOnWeekends && voucher.allowOnPublicHolidays) ? ' and ' + 'Public Holidays' : voucher && voucher.allowOnPublicHolidays ? 'Public Holidays' : '');

        _allowText =
            _applicableStart + ' ' +
            _allowWeekdays +
            _allowWeekends +
            _allowHolidays;
    } else if (type === 'bookingAmount') {
        if (voucher.appliesToBookingAmount) _allowText = 'Applies to Total Booking Amount';
        else _allowText = 'Not applied to Total Booking Amount';
    } else if (type === 'flight') {
        if (voucher.appliesToFlight) _allowText = 'Applicable for this flight';
        else _allowText = 'Applicable to 1 person';
    } else if (type === 'appliesFor') {
        // let _appliesFor = 'Applies for ';
        _allowText = 'Covers ';
        if (!voucher.priceComps || voucher.priceComps.length === 0) _allowText = 'Covers Booking Amount';
        else {
            _allowText += _voucherDetails.priceComps
                .map((a) => {
                    return a.priceComponent.name
                }).reduce((a, b) => {
                    return a + ', ' + b;
                })
        }
    }
    // else if(type === 'usableOtherRewards') {
    //     if(voucher.usa)
    //     _allowText = 
    // }

    return _allowText;

}

getPlayerVoucherClub( ) {
    // vs: Array < TeeTimeClubVoucherSeries >
    let vs: Array < TeeTimeClubVoucherSeries >;
    // if(1) return; //disabled voucher display in the list
    if(this.voucherSeries && this.voucherSeries.length > 0) vs = this.voucherSeries;

    // console.log("check player voucher : ", vs);
    // console.log("check player voucher : ", this.playerVoucher);
    if (this.playerVoucher && this.playerVoucher.length === 0) return;
    if (!this.playerVoucher) return;
    if (!vs) return;
    let _vSeries = vs.filter((vs: TeeTimeClubVoucherSeries) => {
        let _hasVS = this.playerVoucher.filter((pv: TeeTimeClubVoucher) => {
            return vs.id === pv.seriesId
        });
        return _hasVS && _hasVS.length > 0;
    });
    if (_vSeries) return _vSeries
    else return [];
    // else return false;
}

checkPlayerVoucher() {
    // vs: Array < TeeTimeClubVoucherSeries > 
    let vs: Array < TeeTimeClubVoucherSeries >;
    // if(1) return; //disabled voucher display in the list
    if(this.voucherSeries && this.voucherSeries.length > 0) vs = this.voucherSeries
    // console.log("check player voucher [1] : ", vs);
    // console.log("check player voucher [2] : ", this.playerVoucher);
    // console.log("check player voucher [3] : ",this.voucherSeries);
    if (this.playerVoucher && this.playerVoucher.length === 0) return false;
    if (!this.playerVoucher) return false;
    if (!vs) return false;
    let _vSeries = this.playerVoucher.find((pv: TeeTimeClubVoucher) => {
        let _hasVS = vs.filter((vs: TeeTimeClubVoucherSeries) => {
            return vs.id === pv.seriesId
        });
        return _hasVS && _hasVS.length > 0;
    });
    if (_vSeries) return true
    else return false;
}



}
